export const shownProducts = (array, cp, pl) => {
  let i = cp * pl + pl < array.length ? cp * pl + pl : array.length;
  return array.splice(cp * pl, i);
};
